import { LegalPage } from '@/components/LegalPage';
import { privacy } from '@/legal/content';

export default function Privacy() {
  return <LegalPage doc={privacy} />;
}
